var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLogin)?_c('v-footer',{attrs:{"color":"teal","dark":"","app":""}},[_vm._v(" 建設発生土プラント管理システム ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }